import React from 'react';
import './CustomerTile.css';

/**
 * Tile/Card view for a single customer.
 */
export default function CustomerTile({ customer, onEdit }) {
    return (
        <div className="customer-tile" onClick={onEdit}>
            <div className="tile-header">
                <h3 className="customer-name">{customer.name}</h3>
                <span className={`status-dot ${customer.status}`} />
            </div>
            
            <div className="tile-body">
                <div className="customer-num">{customer.customer_number || 'Keine Kundennummer'}</div>
                
                <div className="info-row">
                    <span className="icon">👤</span>
                    <span className="text">{customer.contact_person || 'Kein Ansprechpartner'}</span>
                </div>
                
                <div className="info-row">
                    <span className="icon">📍</span>
                    <span className="text">{customer.address || 'Keine Adresse hinterlegt'}</span>
                </div>
            </div>
            
            <div className="tile-footer">
                <div className="contact-pills">
                    {customer.email && <span className="pill">✉️ E-Mail</span>}
                    {customer.phone && <span className="pill">📞 {customer.phone}</span>}
                </div>
            </div>
        </div>
    );
}
